
import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../action';
import VerifyModal from './VerifyModal';

function Generate2faModal({
  item,
  id,
  handleSuccessModal,
}) {

  const setModal = useContext(ModalContext);

  const verifyQrCode = (e) => {
    e.preventDefault();
    setModal({
      title: "Two Factor Authentication",
      isOpen: true,
      content: <VerifyModal id={id} handleSuccessModal={handleSuccessModal} />,
      modalSize: 'modal-md',
    });
  };

  return (
    <Modal.Body>
      <div className="content">
        <div className="login-box">
          <div className="mt-5 w-96">
            <div className="flex flex-col space-y-1 items-center">
              <div>
                <p className="title-color">Set up via third-party authenticator</p>
                <p className="history-color">Please use your authenticator app (Google Authenticator) to scan this QR code.</p>
              </div>
              <div className="text-center">
                <img
                  alt=""
                  src={`${_.get(item, 'data.qr_code_url')}` || emptyStateImage}
                  style={{ height: '350px', width: '350px', top: '-5px' }}
                  className="border p-3"
                />
              </div>
              <p className="text-center title-color">Set up on same device</p>
              <p className="text-center mt-3 mb-0 history-color text-small">Or enter this code into your authenticator app</p>
              <p className="text-center mt-0 title-color">{`${_.get(item, "data.google2fa_secret")}`}</p>
            </div>
            <div className="pt-5 text-center">
              <button type="submit" className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-block" onClick={verifyQrCode}>
                NEXT
              </button>
            </div>

          </div>
        </div>
      </div>
    </Modal.Body>
  );
}

Generate2faModal.defaultProps = {
  item: {},
  id: '',
};

Generate2faModal.propTypes = {
  item: PropTypes.instanceOf(Object),
  id: PropTypes.string,
  handleSuccessModal: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(
    mapStateToProps,
    {
      ...actions,
    },
  ),
]);

export default enhance(Generate2faModal);